import React, { Component } from 'react'
import { Card, CardHeader, CardBody, Col } from 'reactstrap'
import Variant from './Variant'

class AlbumItem extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.gnObject.id !== nextProps.gnObject.id
  }

  render() {
    const { gnObject, isChild } = this.props
    return (
      <Col
        xs="12"
        md={isChild ? '12' : '6'}
        style={isChild ? { padding: 0 } : {}}
      >
        <Card>
          <CardHeader>Album</CardHeader>
          <CardBody>
            <h5>Business: {gnObject.gnObjectAttached.gnObject.name}</h5>
            <h6>ID: {gnObject.gnObjectAttached.gnObject.id}</h6>
            <hr />
            <h5>{gnObject.name}</h5>

            <br />
            <a
              href={`${APP_BASE_URL}/place/${
                gnObject.gnObjectAttached.gnObject.slug
              }/albums/${gnObject.id}`}
              target="__blank"
              rel="noopener noreferrer"
            >
              Visit Album
            </a>
          </CardBody>
          {this.props.children}
        </Card>
      </Col>
    )
  }
}

export default AlbumItem



// WEBPACK FOOTER //
// ./src/views/Components/AlbumItem.js